import { X } from "lucide-react";
import ReactDOM from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import { closeModal } from "../../features/modalSLice";

const Modal = ({ children }) => {
  const dispatch = useDispatch();
  const isOpen = useSelector((state) => state.modal.isOpen);

  if (!isOpen) return null;
  else
    return ReactDOM.createPortal(
      <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-20 text-text-1/90 overflow-auto">
        <div className="bg-content relative p-6 rounded-md shadow-md  border-2 border-bkg2/60 m-auto">
          <button
            className="absolute top-0.5 right-0.5 m-1.5 p-1 bg-bkg2 text-text-1 rounded-md"
            onClick={() => dispatch(closeModal())}
          >
            <X size={20} />
          </button>
          {children}
        </div>
      </div>,
      document.getElementById("modal-root")
    );
};

export default Modal;
